import {KTCard, KTCardBody} from "../../../../_websoft/helpers";
import {ToastContainer} from "react-toastify";
import React from "react";

const TerminaliArtikli:React.FC = () => {
    return (
        <KTCard>
            <ToastContainer />
            <KTCardBody className='py-4'>
                <div className="row">
                    <div className="col-xl-4 mt-2">
                        <a href="lista" className="card bg-primary hoverable card-xl-stretch mb-xl-8">
                            <div className="card-body"><i className="ki-duotone ki-element-11 text-white fs-3x ms-n1"><span
                                className="path1"></span><span className="path2"></span><span className="path3"></span><span
                                className="path4"></span></i>
                                <div className="text-white fw-bold fs-2 mb-2 mt-5">Lista artikala</div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-4 mt-2">
                        <a href="palete" className="card bg-primary hoverable card-xl-stretch mb-xl-8">
                            <div className="card-body"><i className="ki-duotone ki-element-11 text-white fs-3x ms-n1"><span
                                className="path1"></span><span className="path2"></span><span className="path3"></span><span
                                className="path4"></span></i>
                                <div className="text-white fw-bold fs-2 mb-2 mt-5">Lista paleta</div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-4 mt-2">
                        <a href="promet" className="card bg-primary hoverable card-xl-stretch mb-xl-8">
                            <div className="card-body"><i className="ki-duotone ki-element-11 text-white fs-3x ms-n1"><span
                                className="path1"></span><span className="path2"></span><span className="path3"></span><span
                                className="path4"></span></i>
                                <div className="text-white fw-bold fs-2 mb-2 mt-5">Prometuj artikal</div>
                            </div>
                        </a>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}
export default TerminaliArtikli;
